import { useState } from 'react';
import Header from '../components/layout/Header.jsx';
import Footer from '../components/layout/Footer.jsx';
import Countdown from '../components/coming-soon/Countdown.jsx';
import ParallaxOrb from '../components/coming-soon/ParallaxOrb.jsx';
import CookieBanner from '../components/shared/CookieBanner.jsx';
import { submitToWeb3Forms } from '../lib/web3forms.js';

export default function ComingSoonPage() {
  const [status, setStatus] = useState('idle'); // 'idle' | 'sending' | 'sent' | 'error'
  const [error, setError] = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    if (status === 'sending') return;
    const fields = Object.fromEntries(new FormData(e.currentTarget).entries());
    setStatus('sending');
    setError('');
    try {
      await submitToWeb3Forms({ source: 'Coming Soon', fields });
      setStatus('sent');
    } catch (err) {
      setStatus('error');
      setError(err.message);
    }
  }

  const sending = status === 'sending';
  const sent = status === 'sent';

  return (
    <div className="cs-page">
      <ParallaxOrb />
      <div className="orb orb-2" />
      <div className="orb orb-3" />
      <div className="grid-overlay" />

      <Header variant="minimal" />

      <div className="stage">
        <div className="badge">
          <div className="badge-dot" />
          Lanzamiento inminente
        </div>

        <h1 className="headline">
          La clase está
          <br />
          <em>a punto de empezar</em>
        </h1>

        <p className="headline-sub">
          La academia que enseña lo que el colegio no te enseñó.
          <br />
          Apúntate y entérate antes que nadie.
        </p>

        <Countdown />

        <div className="form-card">
          {sent ? (
            <div className="cs-success">✓ ¡Hecho! Te avisamos antes que a nadie.</div>
          ) : (
            <form className="form-row" onSubmit={onSubmit}>
              <input
                type="email"
                name="email"
                placeholder="tu@email.com"
                required
                disabled={sending}
              />
              <button type="submit" disabled={sending}>
                {sending ? 'Enviando…' : (
                  <>
                    Avísame <span className="arrow">→</span>
                  </>
                )}
              </button>
            </form>
          )}
          {status === 'error' && (
            <div className="cs-error" role="alert">
              {error || 'No hemos podido enviar el formulario. Inténtalo de nuevo.'}
            </div>
          )}
          <p className="form-note">
            Sin spam. Solo el aviso del <span>lanzamiento oficial</span>.
          </p>
          <div className="form-instagram-wrap">
          <a
            className="form-instagram"
            href="https://www.instagram.com/randomcollege_?igsh=ZndiZmpqdjgzYWVx"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Síguenos en Instagram"
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <rect x="3" y="3" width="18" height="18" rx="5" ry="5" />
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
            </svg>
          </a>
          </div>
        </div>
      </div>

      <Footer variant="branded" />
      <CookieBanner />
    </div>
  );
}
